module.exports = __webpack_public_path__ + "assets/media/URLPreview.9a79b9cb.svg";